import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieModule } from '@shared/cookie';
import { Auth } from './auth.service';
import { AUTH_CONFIG } from './auth.config';
import { AuthConfig } from './auth.interface';

@NgModule({
  imports: [
    CookieModule
  ]
})
export class AuthModule {
  static initialize(config: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        Auth,
        { provide: AUTH_CONFIG, useValue: config }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.module.ts